<template>
  <div class="smaller-container-wrapper">
    <MobialisFormWithValidation
      @onValidate="submit"
      novalidate
      v-av-analytics-form-submit="{ elementText: $t('message.common.continue') }"
    >
      <h2>{{ $t('message.eCommerceV2.verifyCreditFormHeading') }}</h2>
      <p
        class="mb-4"
        v-html-safe="
          $t('message.eCommerceV2.verifyCreditFormMsg', {
            creditProvider: this.getDefaultCreditDataSourceCAName.niceName,
          })
        "
      ></p>
      <div v-for="(question, index) in questions" :key="index" data-test="question">
        <h5 class="pb-2 my-3">{{ question }}</h5>
        <MobialisFancyRadio
          :data-av-analytics-element-text-value="`Credit question ${index + 1}`"
          class="pb-2"
          :textArray="choices[index]"
          :name="`Credit question ${index}`"
          v-model="answersArray[index]"
        ></MobialisFancyRadio>
      </div>
      <mobialis-button type="submit" class="my-5" data-cy="continue">{{
        $t('message.common.continue')
      }}</mobialis-button>
    </MobialisFormWithValidation>
    <tool-tip :title="tooltipTitle" :body="tooltipBody"></tool-tip>
  </div>
</template>

<script>
import cloneDeep from 'lodash/fp/cloneDeep';
import { mapGetters } from 'vuex';
import ToolTip from '@/components/ToolTip.vue';
import log from '@/services/log';
import helperFunctions from '@/utils/helperFunctions';
import { AVAnalyticsEventTriggers } from '../../utils/enums';

export default {
  name: 'NameForm',
  components: {
    ToolTip,
  },
  beforeRouteEnter: helperFunctions.onlyAcceptRoutes(['confirm-credit-form', 'step-three']),
  data() {
    return {
      questions: cloneDeep(this.$store.state.credit.questionData.questions),
      choices: cloneDeep(this.$store.state.credit.questionData.choices),
      answersArray: cloneDeep(this.$store.state.credit.questionData.userAnswers),
    };
  },
  computed: {
    ...mapGetters('ecommerceV2', ['getDefaultCreditDataSourceCAName']),
    tooltipTitle() {
      return this.getDefaultCreditDataSourceCAName.niceName;
    },
    tooltipBody() {
      return this.$t('message.eCommerceV2.creditProviderToolTipBody', {
        creditProvider: this.getDefaultCreditDataSourceCAName.niceName,
      });
    },
  },
  methods: {
    async submit(isValid) {
      if (!isValid) {
        return;
      }
      try {
        this.$store.commit('SET_LOADING', true);
        // trigger the end of the credit flow
        helperFunctions.sendAVAnalyticsEvent(this.$route.path, AVAnalyticsEventTriggers.FORM_SUBMIT, this.$store);
        await this.$store.dispatch('credit/getCreditScore', this.answersArray);
        this.$router.push({ path: this.getNextRoutePath() });
      } catch (error) {
        log('Verify credit form', error);
        this.$store.commit('credit/SET_STATE', ['creditChecksFailed', true]);
        this.$router.push('credit-error');
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
};
</script>
